import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32',  // Dark green
    },
    secondary: {
      main: '#fbc02d',  // Yellow
    },
  },
});

export default theme;